/* eslint-disable no-restricted-globals */
import multiplewhite from '../images/activityicons/multiwhite.png';
import multiplegreen from '../images/activityicons/multigreen.png';
import multipleamber from '../images/activityicons/multiamber.png';
import multiplered from '../images/activityicons/multired.png';

import machinewhite from '../images/activityicons/machinewhite.png';
import machinegreen from '../images/activityicons/machinegreen.png';
import machineamber from '../images/activityicons/machineamber.png';
import machinered from '../images/activityicons/machinered.png';

import manuelwhite from '../images/activityicons/manuelwhite.png';
import manuelgreen from '../images/activityicons/manuelgreen.png';
import manuelamber from '../images/activityicons/manuelamber.png';
import manuelred from '../images/activityicons/manuelred.png';

import vechilewhite from '../images/activityicons/vechilewhite.png';
import vechilegreen from '../images/activityicons/vechilegreen.png';
import vechileamber from '../images/activityicons/vechileamber.png';
import vechilered from '../images/activityicons/vechilered.png';

import drumswhite from '../images/activityicons/drumswhite.png';
import drumsgreen from '../images/activityicons/drumsgreen.png';
import drumsamber from '../images/activityicons/drumsamber.png';
import drumsred from '../images/activityicons/drumsred.png';

import manueldeepwhite from '../images/activityicons/manueldeepwhite.png';
import manueldeepgreen from '../images/activityicons/manueldeepgreen.png';
import manueldeepamber from '../images/activityicons/manueldeepamber.png';
import manueldeepred from '../images/activityicons/manueldeepred.png';

import manwhite from '../images/activityicons/manwhite.png';
import mangreen from '../images/activityicons/mangreen.png';
import manamber from '../images/activityicons/manamber.png';
import manred from '../images/activityicons/manred.png';

import tunellingwhite from '../images/activityicons/tunnelingwhite.png';
import tunellingreen from '../images/activityicons/tunnelinggreen.png';
import tunnelingamber from '../images/activityicons/tunnelingamber.png';
import tunnelingred from '../images/activityicons/tunnelingred.png';

import agreewhite from '../images/activityicons/agreewhite.png';
import agreegreen from '../images/activityicons/agreegreen.png';
import agreeamber from '../images/activityicons/agreeamber.png';
import agreered from '../images/activityicons/agreered.png';

import defaultwhite from '../images/activityicons/suspeciouswhite.png';
import defaultred from '../images/activityicons/suspeciousred.png';
import defaultgreen from '../images/activityicons/suspeciousgreen.png';
import defaultamber from '../images/activityicons/suspeciousamber.png';

import suspeciouswhite from '../images/activityicons/suspeciouswhite.png';
import suspeciousred from '../images/activityicons/suspeciousred.png';
import suspeciousgreen from '../images/activityicons/suspeciousgreen.png';
import suspeciousamber from '../images/activityicons/suspeciousamber.png';

// import roadwhite from '../images/activityicons/roadwhite.png';
// import roadred from '../images/activityicons/roadred.png';
// import roadgreen from '../images/activityicons/roadgreen.png';
// import roadamber from '../images/activityicons/roadamber.png';

import clampingwhite from '../images/activityicons/clambingwhite.png';
import clampingred from '../images/activityicons/clambingred.png';
import clampinggreen from '../images/activityicons/clambinggreen.png';
import clampingamber from '../images/activityicons/clambingamber.png';

// import sleevingwhite from '../images/activityicons/sleevingwhite.png';
// import sleevingred from '../images/activityicons/sleevingred.png';
// import sleevinggreen from '../images/activityicons/sleevinggreen.png';
// import sleevingamber from '../images/activityicons/sleevingamber.png';

import trainwhite from '../images/activityicons/trainwhite.png';
import trainred from '../images/activityicons/trainred.png';
import traingreen from '../images/activityicons/traingreen.png';
import trainamber from '../images/activityicons/trainamber.png';


// eslint-disable-next-line no-global-assign
export default event = [
	{
		type: 'Multiple Activities',
		severity: [multiplewhite, multiplegreen, multipleamber, multiplered],
	},
	{
		type: 'Machine Digging',
		severity: [machinewhite, machinegreen, machineamber, machinered],
	},
	{
		type: 'Manual Digging',
		severity: [manuelwhite, manuelgreen, manuelamber, manuelred],
	},
	{
		type: 'Vehicle Movement',
		severity: [vechilewhite, vechilegreen, vechileamber, vechilered],
	},
	{
		type: 'Drums Beating',
		severity: [drumswhite, drumsgreen, drumsamber, drumsred],
	},
	{
		type: 'Manual Digging - Deeper (1.5 to 3 feets)',
		severity: [manueldeepwhite, manueldeepgreen, manueldeepamber, manueldeepred],
	},
	{
		type: 'Man Movement',
		severity: [manwhite, mangreen, manamber, manred],
	},
	{
		type: 'Tunneling',
		severity: [tunellingwhite, tunellingreen, tunnelingamber, tunnelingred],
	},
	{
		type: 'Aggregate Activity',
		severity: [agreewhite, agreegreen, agreeamber, agreered],
	},
	{
		type: 'Unclassified',
		severity: [defaultwhite, defaultgreen, defaultamber, defaultred],
	},
	{
		type: 'Suspicious Activity',
		severity: [suspeciouswhite, suspeciousgreen, suspeciousamber, suspeciousred],
	},
	// {
	// 	type: 'Road Crossing',
	// 	severity: [roadwhite, roadgreen, roadamber, roadred],
	// },
	{
		type: 'Nala Flowing',
		severity: [defaultwhite, defaultgreen, defaultamber, defaultred],
	},
	{
		type: 'Clamping',
		severity: [clampingwhite, clampinggreen, clampingamber, clampingred],
	},
	// {
	// 	type: 'Sleeving',
	// 	severity: [sleevingwhite, sleevinggreen, sleevingamber, sleevingred],
	// },
	{
		type: 'Train Movement',
		severity: [trainwhite, traingreen, trainamber, trainred],
	},
	{
		type: 'Manual Augering',
		severity: [defaultwhite, defaultgreen, defaultamber, defaultred],
	},
	{
		type: 'Machine Augering',
		severity: [defaultwhite, defaultgreen, defaultamber, defaultred],
	},
	{
		type: 'Ploughing Activity',
		severity: [defaultwhite, defaultgreen, defaultamber, defaultred],
	},
	{
		type: 'Ploughing',
		severity: [defaultwhite, defaultgreen, defaultamber, defaultred],
	},
	{
		type: 'Water Pump',
		severity: [defaultwhite, defaultgreen, defaultamber, defaultred],
	},
];

